import { useContext, useEffect, useState } from "react";
import { dispatcher_context } from "../../hooks/useStats_dispatcher";
import { RSODynamicButtonGroup } from "../../../../utils/RSODynamicButtonGroup/RSODynamicButtonGroup"
import { RSODynamicInput } from "../../../../utils/RSODynamicInput/RSODynamicInput"
import { RSODynamicSelect } from "../../../../utils/RSODynamicSelect/RSODynamicSelect"
import { RSODynamicDispEquipmentFailuresPaint } from "./components/RSODynamicDispEquipmentFailuresPaint/RSODynamicDispEquipmentFailuresPaint";
import { getDispatcherAllRepair, getDispatcherAllRepairPeriod, getWPS } from "../../http/dispatcherHttp";
import AuthContext from "../../../../../../context/AuthContext";

export let RSODynamicDispEquipmentFailures = () => {

  let { authTokens } = useContext(AuthContext);

  let { equipmentFailuresTimeTab,
    equipmentFailuresWPS,
    equipmentFailuresFinishRepairTab,
    equipmentFailuresStartPeriod,
    equipmentFailuresEndPeriod,
    equipmentFailuresType,
    equipmentFailuresSelectedWPS,
    setEquipmentFailuresTimeTab,
    setEquipmentFailuresWPS,
    setEquipmentFailuresFinishRepairTab,
    setEquipmentFailuresStartPeriod,
    setEquipmentFailuresEndPeriod,
    setEquipmentFailuresType,
    setEquipmentFailuresSelectedWPS } = useContext(dispatcher_context);

  let [WPS, setWPS] = useState([])


  useEffect(() => {
    getWPS(authTokens, setWPS, setEquipmentFailuresWPS)
  }, [])

  return (
    <div className="large__container">
      <div className="container RSODynamicControls">
        <div className="RSODynamicControls__row">
          <RSODynamicSelect
            name='Выберите ВЗУ'
            list={equipmentFailuresWPS}
            value='id'
            parse='int'
            visible_value='name'
            selectedDate={equipmentFailuresSelectedWPS}
            setter={setEquipmentFailuresSelectedWPS}
            getter={equipmentFailuresSelectedWPS} />
        </div>

        <div className="RSODynamicControls__row">
          <div>
            <RSODynamicButtonGroup
              buttons={[
                { title: 'Отказы всего' },
                { title: 'Отказы за период' },
              ]}
              setter={setEquipmentFailuresTimeTab}
              getter={equipmentFailuresTimeTab}
              color='green' />
          </div>
          <div>
            <RSODynamicButtonGroup
              buttons={[
                { title: 'Скважины' },
                { title: 'Насосы' },
              ]}
              setter={setEquipmentFailuresType}
              getter={equipmentFailuresType}
              color='green' />
          </div>
          <div>
            <RSODynamicButtonGroup
              buttons={[
                { title: 'Завершено' },
                { title: 'В ремонте' },
              ]}
              setter={setEquipmentFailuresFinishRepairTab}
              getter={equipmentFailuresFinishRepairTab}
              color='green' />
          </div>
        </div>

        <div className="RSODynamicControls__row">
          {equipmentFailuresTimeTab === "Отказы за период" &&
            <>
              <div>
                <RSODynamicInput
                  type='date'
                  title='Выберите начало периода'
                  name='selectDate'
                  setter={setEquipmentFailuresStartPeriod}
                  required={true}
                />
              </div>
              <div>
                <RSODynamicInput
                  type='date'
                  title='Выберите конец периода'
                  name='selectDate'
                  setter={setEquipmentFailuresEndPeriod}
                  required={true}
                />
              </div>
            </>
          }
        </div>
      </div>

      {equipmentFailuresTimeTab === 'Отказы всего' &&
        <RSODynamicDispEquipmentFailuresPaint
          getFunc={getDispatcherAllRepair} />
      }

      {equipmentFailuresTimeTab === 'Отказы за период' &&
        <RSODynamicDispEquipmentFailuresPaint
          title="period"
          getFunc={getDispatcherAllRepairPeriod} />
      }

    </div>
  )
}
